import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Search, X } from "lucide-react";
import { getProducts } from "@/lib/api";
import { cadShort } from "@/lib/site";

export const SearchOverlay = ({ open, onClose }) => {
  const [q, setQ] = useState("");
  const [all, setAll] = useState([]);
  const inputRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) return;
    if (!all.length) getProducts().then(setAll).catch(() => {});
    setTimeout(() => inputRef.current?.focus(), 50);
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose, all.length]);

  const results = q.trim() ? all.filter((p) => p.name.toLowerCase().includes(q.trim().toLowerCase())) : [];
  const submit = (e) => {
    e.preventDefault();
    onClose();
    navigate(`/shop${q.trim() ? `?q=${encodeURIComponent(q.trim())}` : ""}`);
  };

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[70] bg-ink/30" onClick={onClose} data-testid="search-overlay">
      <div role="dialog" aria-label="Search products" className="bg-cloud animate-in fade-in slide-in-from-top-2 duration-300" onClick={(e) => e.stopPropagation()}>
        <form onSubmit={submit} className="mx-auto flex max-w-[1440px] items-center gap-4 border-b border-ink/10 px-5 py-8 sm:px-10">
          <Search size={22} strokeWidth={1.5} aria-hidden="true" />
          <label htmlFor="header-search" className="sr-only">Search products</label>
          <input id="header-search" ref={inputRef} value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search products" className="flex-1 bg-transparent text-2xl placeholder:text-ink/35 focus:outline-none sm:text-3xl" data-testid="header-search-input" />
          <button type="button" onClick={onClose} aria-label="Close search" className="p-1 hover:opacity-60" data-testid="header-search-close"><X size={22} strokeWidth={1.5} /></button>
        </form>
        {q.trim() && (
          <ul className="mx-auto grid max-w-[1440px] gap-x-6 px-5 py-6 sm:grid-cols-2 sm:px-10 lg:grid-cols-4" data-testid="header-search-results">
            {results.length === 0 && <li className="text-ink/60">No products match "{q}".</li>}
            {results.map((p) => (
              <li key={p.slug}>
                <Link to={`/product/${p.slug}`} onClick={onClose} className="flex items-center gap-4 py-3 transition-opacity hover:opacity-60" data-testid={`header-search-result-${p.slug}`}>
                  <span className="tile h-16 w-16 shrink-0"><img src={p.images[0].src} alt="" className="h-full w-full object-cover mix-blend-multiply" /></span>
                  <span><span className="block text-[15px]">{p.name}</span><span className="text-[13px] text-ink/55">{cadShort(p.price)}</span></span>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
